/** Ein Weg im Router: die Befehle des Pfads. */
export interface TestRunLink {
  commands: string[];
}

/**
 * Der Weg auf die Durchlaeufe-Zwischenebene eines Laufs (NEX-1037).
 *
 * <p>An einer Stelle, weil mehrere Sichten dorthin fuehren. Die Art traegt der Weg nicht: Die Ebene liest sie
 * aus dem Lauf selbst (NEX-1838).
 */
export function testRunExecutionsLink(projectId: string, runId: string): TestRunLink {
  return { commands: ['/projects', projectId, 'test-runs', runId, 'executions'] };
}
